var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.52 12.271C23.52 11.42 23.4436 10.6019 23.3018 9.81641H12V14.4582H18.4582C18.18 15.9582 17.3345 17.2291 16.0636 18.08V21.091H19.9418C22.2109 19.0019 23.52 15.9255 23.52 12.271Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.001 24.0013C15.241 24.0013 17.9573 22.9267 19.9428 21.094L16.0646 18.0831C14.9901 18.8031 13.6155 19.2285 12.001 19.2285C8.87553 19.2285 6.23007 17.1176 5.28643 14.2812H1.27734V17.3903C3.25189 21.3122 7.31007 24.0013 12.001 24.0013Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.28545 14.2785C5.04545 13.5585 4.90909 12.7894 4.90909 11.9985C4.90909 11.2076 5.04545 10.4385 5.28545 9.71847V6.60938H1.27636C0.463636 8.22938 0 10.0621 0 11.9985C0 13.9348 0.463636 15.7676 1.27636 17.3876L5.28545 14.2785Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.001 4.77273C13.7628 4.77273 15.3446 5.37818 16.5883 6.56727L20.0301 3.12545C17.9519 1.18909 15.2355 0 12.001 0C7.31007 0 3.25189 2.68909 1.27734 6.61091L5.28643 9.72C6.23007 6.88364 8.87553 4.77273 12.001 4.77273Z",
    fill: "#EA4335"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.0230aa3f042e1f1e2299bde25695c76d.svg";
export { ForwardRef as ReactComponent };